var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8209 13.1795H27.7637V13.125H15.9512V18.375H23.3688C22.2866 21.4312 19.3788 23.625 15.9512 23.625C11.6022 23.625 8.07617 20.099 8.07617 15.75C8.07617 11.401 11.6022 7.875 15.9512 7.875C17.9586 7.875 19.785 8.63231 21.1756 9.86934L24.888 6.15694C22.5439 3.97228 19.4083 2.625 15.9512 2.625C8.70289 2.625 2.82617 8.50172 2.82617 15.75C2.82617 22.9983 8.70289 28.875 15.9512 28.875C23.1995 28.875 29.0762 22.9983 29.0762 15.75C29.0762 14.87 28.9856 14.0109 28.8209 13.1795Z",
    fill: "#FFC107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33984 9.64097L8.65206 12.8034C9.81887 9.91463 12.6447 7.875 15.9515 7.875C17.959 7.875 19.7853 8.63231 21.1759 9.86934L24.8883 6.15694C22.5442 3.97228 19.4087 2.625 15.9515 2.625C10.9102 2.625 6.53828 5.47116 4.33984 9.64097Z",
    fill: "#FF3D00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9511 28.8752C19.3413 28.8752 22.4218 27.5778 24.7508 25.468L20.6886 22.0305C19.3266 23.0663 17.6623 23.6266 15.9511 23.6252C12.5373 23.6252 9.63866 21.4484 8.54666 18.4106L4.2666 21.7083C6.43879 25.9588 10.8501 28.8752 15.9511 28.8752Z",
    fill: "#4CAF50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8209 13.1795H27.7637V13.125H15.9512V18.375H23.3688C22.8511 19.8295 21.9187 21.1005 20.6867 22.031L20.6886 22.0297L24.7508 25.4671C24.4634 25.7283 29.0762 22.3125 29.0762 15.75C29.0762 14.87 28.9856 14.0109 28.8209 13.1795Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.0433beac2e20184d8cdb91d10786ec78.svg";
export { ForwardRef as ReactComponent };